import {Component} from '@angular/core';
import {FacebookService, InitParams} from 'ngx-facebook';
import {GlobalService} from './_services/global.service';
import {AccountService} from './_services/account.service';
import {ProjectsService} from './_services/projects.service';
import {Router} from '@angular/router';

declare var $: any;

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public isLoaded = false;

  
  constructor(private fb: FacebookService,
              private globalService: GlobalService,
              private accountService: AccountService,
              private projectsService: ProjectsService,
              private router: Router) {
    let initParams: InitParams = {
      appId: '658174577866187',
      xfbml: true,
      version: 'v2.9'
    };
    fb.init(initParams);

  }
}





// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/app.component.ts